// utils/dateUtils.js

export const formatToSpanishTimeZone = (dateString, includeTime = false) => {
  const date = new Date(dateString);
  const options = { timeZone: 'Europe/Madrid' };

  const day = date.toLocaleString('es-ES', { ...options, day: '2-digit' });
  const month = date.toLocaleString('es-ES', { ...options, month: '2-digit' });
  const year = date.toLocaleString('es-ES', { ...options, year: 'numeric' });

  if (includeTime) {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  } else {
    return `${day}/${month}/${year}`;
  }
};


  export const formatTimeToSpanishTimeZone = (timeString) => {
    const date = new Date(timeString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  export const formatFromDatePicker = (timeString) => {
    const parts = timeString.split('-'); // Divide la cadena en partes
    return `${parts[2]}/${parts[1]}/${parts[0]}`; // Reordena las partes y forma la nueva cadena
  };
  
  
  
  
  // utils/dateUtils.js

export const addDaysAndFormat = (isoDate, daysToAdd) => {
    // Paso 1: Convertir la cadena ISO en un objeto Date
    const date = new Date(isoDate);
  
    // Paso 2: Sumar los días
    date.setDate(date.getDate() + daysToAdd);
  
    // Paso 3: Formatear la fecha
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Enero es 0, diciembre es 11
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`;
  };
  